module.exports = __webpack_public_path__ + "static/img/zhongzhongka14.015de5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka14.png
// module id = Kf8l
// module chunks = 16